module.exports = __webpack_public_path__ + "img/profile-prompt.d3e20292.svg";